
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Injectable } from '@angular/core';
import { switchMap, first, take, map } from "rxjs/operators";
import * as firebase from "firebase/app";
import { Observable } from 'rxjs';
import { AuthService } from '@app/core/services';

import { combineLatest } from 'rxjs/observable/combineLatest';

import * as moment from 'moment';
import { UtilsService } from '@app/core/services/utils.service';
import { TaskService } from '@app/core/services/task.service';

export interface Order {
  uid: string;
  number: number;
  shop: string;
  office: string;
  createdAt: Date;
  type: string;   //Comida, Motorizado
  status: string;
  userRequest: any;
  userAssigns: any;
  dealer: string;
  travelTime: number;
  imgAdjunt: string;
}

@Injectable()
export class OrdersDAO {

  private ref: string = "orders";

  states: any = [];

  constructor(public afs: AngularFirestore,
    private utils: UtilsService,
    private taskService: TaskService)//,private session: AuthService) 
  {
    this.loadStates();
  }

  loadStates() {
    this.states['confirmar'] = { message: 'Solicitud aceptada por local', statusdb: 'Confirmada', actionTimeline: 'Local acepta la orden de pedido' };
    this.states['rechazar'] = { message: 'La orden ha sido cancelada', statusdb: 'Cancelada', actionTimeline: 'Local ha cancelado la orden de pedido.' };
    this.states['cancelar'] = { message: 'La orden ha sido cancelada', statusdb: 'Cancelada', actionTimeline: 'Local ha cancelado la solicitud de motorizado.' };
  }

  async updateOrder(order: any, user: any, locationDelivery: any) {
    if (order.client) {
      if (locationDelivery)
        if (locationDelivery.latitude) {
          let locationDeliveryFire: any = null;
          locationDeliveryFire = new firebase.firestore.GeoPoint(locationDelivery.latitude, locationDelivery.longitude);
          order.client.location = locationDeliveryFire;
        }
    }

    let refOrder = this.afs.firestore.collection('orders').doc(order.uid);

    return await this.afs.firestore.runTransaction(async transaction => {
      transaction.set(refOrder, {
        userLastUpdate: user,
        imgAdjunt: order.imgAdjunt,
        travelTime: order.travelTime,
        client: order.client,
        productsDescription: order.productsDescription || null,
        purchasePrice: order.purchasePrice || null,
      },
        { merge: true });
      return order.uid;
    })
      .then(orderId => {
        return orderId;
      })
      .catch(error => {
        console.error('Transaction failed: ', error);
        throw error;
      });
  }

  async updateRequestDealer(
    time: number,
    office: any,
    user: any,
    request: any,
    locationRq: any,
    urlImg: string) {


    let refOrder = this.afs.firestore.collection('orders').doc(request.uid);


    return await this.afs.firestore.runTransaction(async transaction => {

      let locationDelivery: any = null;
      if (request.locationDelivery) {
        locationDelivery = new firebase.firestore.GeoPoint(request.locationDelivery.latitude, request.locationDelivery.longitude);
      }

      let locationOffice: any = null;
      if (office.uid == 'base') {
        if (request.locationStart != null) {
          locationOffice = new firebase.firestore.GeoPoint(request.locationStart.latitude, request.locationStart.longitude);
        }
      } else if (office.location) {
        locationOffice = new firebase.firestore.GeoPoint(office.location._lat, office.location._long);
      }

      let locationRequest: any = null;
      if (locationRq.latitude) {
        locationRequest = new firebase.firestore.GeoPoint(locationRq.latitude, locationRq.longitude);
      }

      let auxAddressStart = null;
      if(typeof request.addressStart !== "string"){
        auxAddressStart = request.addressStart;
        request.addressStart = auxAddressStart.address;
      }

      let auxAddressEnd = null;
      if(typeof request.addressDelivery !== "string"){
        auxAddressEnd = request.addressDelivery;
        request.addressDelivery = auxAddressEnd.address;
      }

      //-------------------------------------------------------------

      let data:any = {

        // shop: {uid: office.shop.uid, name: office.shop.name},
        office: {
          uid: office.uid,
          name: office.name,
          address: request.addressStart ? request.addressStart : office.address || '',
          location: locationOffice
        },
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        type: "Motorizado",   //Comida, Motorizado
        status: request.status,
        userLastUpdate: { uid: user.uid, name: user.displayName, location: locationRequest },
        //imgAdjunt: request.attachments.length > 0 ? request.attachments[0].url : null,
        attachments: request.attachments,
        travelTime: time,
        client: {
          name: request.clientName || '',
          phone: request.phone || '',
          address: request.addressDelivery || '',
          location: locationDelivery
        },
        priceDelivery: this.utils.toNumber(request.priceDelivery) || null,
        purchasePrice: this.utils.toNumber(request.purchasePrice) || null,
        productsDescription: request.products || null,
        distanceDelivery: request.distanceDelivery
      };

      if(auxAddressStart !== null){
        data.office.office = {
          uid: auxAddressStart.uid,
          name: auxAddressStart.name,
          shop: {
            name: auxAddressStart.shop.name,
            uid: auxAddressStart.shop.uid
          }
        };
      }

      if(auxAddressEnd !== null){
        data.client.client = {
          uid: auxAddressEnd.uid,
          name: auxAddressEnd.name
        };
      }

      transaction.set(refOrder, data,
        { merge: true });
      return request.number;
    })
      .then(orderId => {
        return orderId;
      })
      .catch(error => {
        console.error('Transaction failed: ', error);
        throw error;
      });


  }

  async newRequestProgrammed(
    dateOrder: any,
    notificationTime: number,
    office: any,
    user: any,
    request: any,
    locationRequest: any) {

    const data = {
      dateOrder,
      notificationTime,
      office,
      user,
      request,
      locationRequest
    };

    //console.log(data);

    //console.log(new Date(dateOrder).getTime()-(notificationTime*60*1000));

    let time: number = new Date(dateOrder).getTime() - (notificationTime * 60 * 1000);

    this.taskService.performAt(
      time,
      'scheduledOrder',
      data);
  }

  async newRequestDealer(
    time: number,
    office: any,
    user: any,
    request: any,
    locationRq: any,
    urlImg: string) {

    let uidOrder = this.afs.createId();
    let refCount = this.afs.firestore.collection('params').doc('sequences');
    let refOrder = this.afs.firestore.collection('orders').doc(uidOrder);

    let url = urlImg ? urlImg : '';

    return await this.afs.firestore.runTransaction(async transaction => {

      const doc = await transaction.get(refCount);


      let orderNum = 0;
      // if it does not exist set the population to one
      if (!doc.exists) {
        transaction.set(refCount, { orderNumber: 0 });
        orderNum = 1;
      }

      // exists already so lets increment it + 1
      const newOrderNum = doc.data().orderNumber + 1;

      transaction.update(refCount, {
        orderNumber: newOrderNum,
      });

      let locationDelivery: any = null;
      if (request.locationDelivery) {
        locationDelivery = new firebase.firestore.GeoPoint(request.locationDelivery.latitude, request.locationDelivery.longitude);
      }

      let locationOffice: any = null;
      if (office.uid == 'base') {
        if (request.locationStart != null) {
          locationOffice = new firebase.firestore.GeoPoint(request.locationStart.latitude, request.locationStart.longitude);
        }
      } else if (office.location) {
        locationOffice = new firebase.firestore.GeoPoint(office.location._lat, office.location._long);
      }

      let locationRequest: any = null;
      if (locationRq.latitude) {
        locationRequest = new firebase.firestore.GeoPoint(locationRq.latitude, locationRq.longitude);
      }

      let auxAddressStart = null;
      if(typeof request.addressStart !== "string" && request.addressStart !== null){
        
        auxAddressStart = request.addressStart;
        request.addressStart = auxAddressStart.address;
      }

      let auxAddressEnd = null;
      if(typeof request.addressDelivery !== "string" && request.addressDelivery !== null){
        auxAddressEnd = request.addressDelivery;
        request.addressDelivery = auxAddressEnd.address;
      }

      let data:any = {
        uid: uidOrder,
        number: newOrderNum,
        shop: { uid: office.shop.uid, name: office.shop.name },
        office: {
          uid: office.uid,
          name: office.alias,
          address: request.addressStart ? request.addressStart : office.address || '',
          location: locationOffice
        },
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        type: "Motorizado",   //Comida, Motorizado
        status: "Solicitada",
        userRequest: { uid: user.uid, name: user.displayName, location: locationRequest },
        userAssigns: null,
        dealer: null,
        imgAdjunt: request.attachments.length > 0 ? request.attachments[0].url : null,
        attachments: request.attachments,
        travelTime: time,
        client: {
          uid: null,
          name: request.clientName || '',
          phone: request.phone || '',
          address: request.addressDelivery || '',
          location: locationDelivery
        },
        distanceDelivery: request.distanceDelivery || '',
        priceDelivery: this.utils.toNumber(request.priceDelivery) || null,
        purchasePrice: this.utils.toNumber(request.purchasePrice) || null,
        productsDescription: request.products || null
      };

      if(auxAddressStart !== null){
        data.office.office = {
          uid: auxAddressStart.uid,
          name: auxAddressStart.name,
          shop: {
            name: auxAddressStart.shop.name,
            uid: auxAddressStart.shop.uid
          }
        };
      }

      if(auxAddressEnd !== null){
        data.client.client = {
          uid: auxAddressEnd.uid,
          name: auxAddressEnd.name
        };
      }


      transaction.set(refOrder, data);
      // return the new value so we know what the new population is
      return newOrderNum;
    })
      .then(ordernumber => {
        return ordernumber;
      })
      .catch(error => {
        console.error('Transaction failed: ', error);
        throw error;
      });
  }

  async newRequestDealerWithAssign(
    time: number,
    office: any,
    user: any,
    request: any,
    locationRq: any,
    urlImg: string,
    dealer: any) {

    let uidOrder = this.afs.createId();
    let refCount = this.afs.firestore.collection('params').doc('sequences');
    let refOrder = this.afs.firestore.collection('orders').doc(uidOrder);
    let refUser = this.afs.firestore.collection('dealers').doc(dealer.uid);

    let url = urlImg ? urlImg : '';

    return await this.afs.firestore.runTransaction(async transaction => {

      const doc = await transaction.get(refCount);

      let orderNum = 0;
      // if it does not exist set the population to one
      if (!doc.exists) {
        transaction.set(refCount, { orderNumber: 0 });
        orderNum = 1;
      }

      // exists already so lets increment it + 1
      const newOrderNum = doc.data().orderNumber + 1;

      transaction.update(refCount, {
        orderNumber: newOrderNum,
      });

      let locationDelivery: any = null;
      if (request.locationDelivery) {
        locationDelivery = new firebase.firestore.GeoPoint(request.locationDelivery.latitude, request.locationDelivery.longitude);
      }

      let locationOffice: any = null;
      if (office.uid == 'base') {
        if (request.locationStart != null) {
          locationOffice = new firebase.firestore.GeoPoint(request.locationStart.latitude, request.locationStart.longitude);
        }
      } else if (office.location) {
        locationOffice = new firebase.firestore.GeoPoint(office.location._lat, office.location._long);
      }

      let locationRequest: any = null;
      if (locationRq.latitude) {
        locationRequest = new firebase.firestore.GeoPoint(locationRq.latitude, locationRq.longitude);
      }

      let price = this.utils.toNumber(request.priceDelivery);
      request.purchasePrice = this.utils.toNumber(request.purchasePrice);

      let auxAddressStart = null;
      if(typeof request.addressStart !== "string"){
        auxAddressStart = request.addressStart;
        request.addressStart = auxAddressStart.address;
      }

      let auxAddressEnd = null;
      if(typeof request.addressDelivery !== "string"){
        auxAddressEnd = request.addressDelivery;
        request.addressDelivery = auxAddressEnd.address;
      }

      let data:any = {
        uid: uidOrder,
        number: newOrderNum,
        shop: { uid: office.shop.uid, name: office.shop.name },
        office: {
          uid: office.uid,
          name: office.alias,
          address: request.addressStart ? request.addressStart : office.address || '',
          location: locationOffice
        },
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        type: "Motorizado",   //Comida, Motorizado
        status: "Solicitada",
        userRequest: { uid: user.uid, name: user.displayName, location: locationRequest },
        userAssigns: null,
        dealer: null,
        imgAdjunt: request.attachments.length > 0 ? request.attachments[0].url : null,
        attachments: request.attachments,
        travelTime: time,
        client: {
          uid: null,
          name: request.clientName || '',
          phone: request.phone || '',
          address: request.addressDelivery || '',
          location: locationDelivery
        },
        distanceDelivery: request.distanceDelivery || '',
        priceDelivery: price || null,
        purchasePrice: request.purchasePrice || null,
        productsDescription: request.products || null
      };

      if(auxAddressStart !== null){
        data.office.office = {
          uid: auxAddressStart.uid,
          name: auxAddressStart.name,
          shop: {
            name: auxAddressStart.shop.name,
            uid: auxAddressStart.shop.uid
          }
        };
      }

      if(auxAddressEnd !== null){
        data.client.client = {
          uid: auxAddressEnd.uid,
          name: auxAddressEnd.name
        };
      }

      transaction.set(refOrder, data);

      transaction.set(refOrder, {
        dealer: { uid: dealer.uid, name: dealer.displayName },
        //distanceDelivery: request.distanceDelivery,
        //priceDelivery: request.priceDelivery || 0,
        dateAssign: firebase.firestore.FieldValue.serverTimestamp(),
        status: 'Asignada',
        userAssigns: { uid: user.uid, name: user.displayName, location: locationRequest },
      }, { merge: true });

      transaction.update(refUser, {
        status: 'Asignado',
      });
      // return the new value so we know what the new population is
      return newOrderNum;
    })
      .then(ordernumber => {
        return ordernumber;
      })
      .catch(error => {
        console.error('Transaction failed: ', error);
        throw error;
      });
  }

  async assignDealer(order: any, dealer: any) {

    // order.userAssigns=this.session.getUser();
    order.priceDelivery = this.utils.toNumber(order.priceDelivery);

    let refUser = this.afs.firestore.collection('dealers').doc(dealer.uid);
    let refOrder = this.afs.firestore.collection('orders').doc(order.uid);

    return await this.afs.firestore.runTransaction(async transaction => {
      transaction.set(refOrder, {
        dealer: { uid: dealer.uid, name: dealer.displayName, code: dealer.code },
        distanceDelivery: order.distanceDelivery,
        priceDelivery: order.priceDelivery || 0,
        dateAssign: firebase.firestore.FieldValue.serverTimestamp(),
        status: 'Asignada',
        userAssigns: order.userAssigns,
      }, { merge: true });

      transaction.update(refUser, {
        status: 'Asignado',

      });
      return order.uid;
    })
      .then(orderId => {
        return orderId;
      })
      .catch(error => {
        console.error('Transaction failed: ', error);
        throw error;
      });
  }








  getOrders(office?) {
    if (office === undefined) {
      return this.afs.collection('orders', (ref) =>
        ref.orderBy('createdAt', 'desc')
      );
    } else {
      return this.afs.collection('orders', (ref) =>
        ref.where('office.uid', '==', office)
          .orderBy('createdAt', 'desc')
      );
    }
  }
  getOrdersActives(office?) {
    let lst1;
    let lst2;
    if (office === undefined) {
      lst1 = this.afs.collection('orders', (ref) =>
        ref.where("status", "<", "Entregada")
      ).valueChanges();

      lst2 = this.afs.collection('orders', (ref) =>
        ref.where("status", ">", "Entregada")
      ).valueChanges();
    } else {
      lst1 = this.afs.collection('orders', (ref) =>
        ref.where("office.uid", "==", office)
          .where("status", "<", "Entregada")
      ).valueChanges();

      lst2 = this.afs.collection('orders', (ref) =>
        ref.where("office.uid", "==", office)
          .where("status", ">", "Entregada")
      ).valueChanges();
    }



    const combinedList = combineLatest<any[]>(lst1, lst2).pipe(
      map(arr => arr.reduce((acc, cur) => acc.concat(cur))),
      map(items => items.sort(this.sortByCreatedAt))
    )

    return combinedList;
  }

  sortByCreatedAt(a, b) {
    if (a.createdAt < b.createdAt) { return 1; }
    if (a.createdAt > b.createdAt) { return -1; }
    return 0;
  }
  sortByArrivalAt(a, b) {
    
    if (a.createdAt > b.createdAt ) { return 1; }
    if (a.createdAt < b.createdAt) { return -1; }
    return 0;
  }


  getDealers(): Observable<any[]> {
    let collection: AngularFirestoreCollection<any>;
    collection = this.afs.collection('dealers');
    return collection.snapshotChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data();
          return { id: a.payload.doc.id, ...data };
        });
      })
    );
  }
  //let collection: AngularFirestoreCollection<any>;

  getDealersOffice(): Observable<any[]> {
    return this.afs.collection('dealers', ref =>
      ref.where('online', '==', true)).valueChanges() as Observable<any[]>;

  }

  getAllOrders(): Observable<any[]> {

    const time = firebase.firestore.FieldValue.serverTimestamp() as firebase.firestore.Timestamp;
    let date = moment(time).format('YYYY-MM-DD');

    const start = new Date(date + ' 00:00');
    const end = new Date(date + ' 23:59');

    return this.afs.collection('orders', ref =>
      ref.where("createdAt", ">=", start)
        .where("createdAt", "<=", end)
        .orderBy('createdAt', 'desc')).valueChanges() as Observable<any[]>;
  }

  getOrdersSolicitadas(): Observable<any[]> {

    const time = firebase.firestore.FieldValue.serverTimestamp() as firebase.firestore.Timestamp;
    let date = moment(time).format('YYYY-MM-DD');

    const start = new Date(date + ' 00:00');
    const end = new Date(date + ' 23:59');

    let lst1 = this.afs.collection('orders', ref =>
        ref.where("status", "==", 'Confirmada')
      ).valueChanges();

    let lst2 = this.afs.collection('orders', ref =>
      ref.where("status", "==", 'Solicitada')
    ).valueChanges() as Observable<any[]>;


    const combinedList = combineLatest<any[]>(lst1, lst2).pipe(
      map(arr => arr.reduce((acc, cur) => acc.concat(cur))),
      map(items => items.sort(this.sortByArrivalAt))
    )

    return combinedList;
  }

  getOrdersAsignadas(): Observable<any[]> {

    const time = firebase.firestore.FieldValue.serverTimestamp() as firebase.firestore.Timestamp;
    
    let lst1 = this.afs.collection('orders', ref =>
        ref.where("status", "==", 'Asignada')
          .orderBy("dateAssign", "asc")
      ).valueChanges();

    return lst1;
  }


  getOrdersPendientes(): Observable<any[]> {

    const time = firebase.firestore.FieldValue.serverTimestamp() as firebase.firestore.Timestamp;
    let date = moment(time).format('YYYY-MM-DD');

    return this.afs.collection('orders', ref =>
      ref.where("status", "==", 'Pendiente')
    ).valueChanges() as Observable<any[]>;
  }


  getOrdersSolicitadas2() {
    let lst1;
    let lst2;

    lst1 = this.afs.collection('orders', (ref) =>
      ref.where("status", "==", "Solicitada")
    ).valueChanges();

    lst2 = this.afs.collection('orders', (ref) =>
      ref.where("status", "==", "Pendiente")
    ).valueChanges();

    const combinedList = combineLatest<any[]>(lst1, lst2).pipe(
      map(arr => arr.reduce((acc, cur) => acc.concat(cur))),
      map(items => items.sort(this.sortByCreatedAt))
    )

    return combinedList;
  }

  getOrdersDealer(dealer): Observable<any[]> {
    return this.afs.collection('orders', ref =>
      ref.where("status", "<", 'Entregada')
        .where("dealer.uid", "==", dealer)
    ).valueChanges() as Observable<any[]>;
  }

  async searchOrderById(uid: string) {
    try {
      let aux = await this.afs.collection("admins",
        ref => ref.where('uid', '==', uid)
          .where('delete', '==', false))
        .valueChanges().pipe(first()).toPromise().then(doc => {
          return doc;
        }).catch(error => {
          throw error;
        });
      if (aux.length == 0)
        return {};
      return aux[0];
    } catch (error) {
      console.error("Error searchUserByEmail", error);
      throw error;
    }
  }


  async setStateOrder(order: any, status: any, user: any) {
    let uidOrder = order.uid;
    let uidTimeline = this.afs.createId();
    let refOrder = this.afs.firestore.collection('orders').doc(uidOrder);
    let reftimeline = this.afs.firestore.collection('orders').doc(uidOrder).collection('timeline').doc(uidTimeline);
    //let refUser = this.afs.firestore.collection('dealers').doc(user.uid);

    let state = this.states[status];

    return await this.afs.firestore.runTransaction(async transaction => {

      if (state.statusdb == 'Confirmada') {
        transaction.update(refOrder, {
          status: state.statusdb,
          dateConfirmOrder: firebase.firestore.FieldValue.serverTimestamp(),
          travelTime: order.travelTime
        });
      }
     


      if (state.statusdb == 'Solicitada') {
        transaction.update(refOrder, {
          status: state.statusdb,
          dateRequestOrder: firebase.firestore.FieldValue.serverTimestamp(),
        });
      }

      else if (state.statusdb == 'Cancelada') {
        transaction.update(refOrder, {
          status: state.statusdb,
          dateCancelOrder: firebase.firestore.FieldValue.serverTimestamp(),
          reasonCancel: order.reasonCancel || ''
        });
      }

      transaction.set(reftimeline, {
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        uid: user.uid,
        userType: 'client',
        action: state.actionTimeline || ''
      }, { merge: true });
      return true;
    })
      .then(state => {
        return state;
      })
      .catch(error => {
        console.error('Transaction failed: ', error);
        throw error;
      });
  }

  getCancellationReasons() {
    return this.afs.collection('cancellation-reasons', (ref) =>
      ref
    );
  }

  getActivesCancellationReasons() {
    return this.afs.collection('cancellation-reasons', (ref) =>
      ref.where("active", "==", true)
    );
  }

  async saveCancellationReason(element: any) {

    var uid = null;
    if (element.uid)
      uid = element.uid;
    else
      uid = this.afs.createId();

    element.uid = uid;

    let refElement = this.afs.firestore.collection('cancellation-reasons').doc(uid);
    return await this.afs.firestore.runTransaction(async transaction => {
        transaction.set(refElement, element);
        return uid;
      })
      .then(uid => {
        return uid;
      })
      .catch(error => {
        console.error('Transaction failed on cancellation-reasons :', error);
        throw error;
      });

  }

  getStatusOffice(status){
      switch(status){
        case 'Pendiente': 
          return 'Pendiente';
        case 'Confirmada': 
          return 'Preparando pedido';
        case 'Solicitada': 
          return 'Motorizado solicitado';
        case 'Asignada': 
          return 'Motorizado asignado';
        case 'Aceptada': 
          return 'Motorizado en camino';
        case 'Rechazada': 
          return 'Motorizado asignado';
        case 'En Local': 
          return 'Esperando    pedido';
        case 'En camino': 
          return 'En camino';
        case 'Entregada': 
          return 'Entregado';
        case 'Cancelada': 
          return 'Cancelado';
        case 'Incidente': 
          return 'Incidente';
        default:
          return status;
      }
    
  }
}
